import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowRight, RefreshCw } from "lucide-react";
import { convertLine, fmtMoney, fmtNum, rateOf } from "@/lib/lineMath";

const fxLabel = (fx, c) => {
  const v = fx?.[c];
  if (c === "TRY" || !v) return null;
  return `1 ${c} = ₺${fmtNum(v.rate, 4)} · ${v.date || "—"} · ${v.source === "order" ? "sipariş kuru" : "günün TCMB kuru"}`;
};

// Bilinçli para birimi değişimi önizlemesi — onaylanmadan fiyat çevrilmez
export default function CurrencyConvertDialog({ req, fx, onConfirm, onCancel }) {
  const rows = req?.rows || [];
  const to = req?.to;
  const froms = [...new Set(rows.map((r) => r.currency || "TRY"))];
  const missing = [to, ...froms].some((c) => !rateOf(fx, c));
  return (
    <Dialog open={!!req} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="bg-slate-950 border-slate-800 text-slate-100 max-w-xl" data-testid="ws-convert-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <RefreshCw className="w-4 h-4 text-blue-400" /> Para Birimi Değişimi → {to}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2 text-xs">
          {[...froms, to].filter((c, i, a) => a.indexOf(c) === i).map((c) => fxLabel(fx, c) && (
            <div key={c} className="font-mono text-slate-400" data-testid={`ws-convert-rate-${c}`}>{fxLabel(fx, c)}</div>
          ))}
          <div className="max-h-72 overflow-y-auto border border-slate-800 rounded-sm divide-y divide-slate-800">
            {rows.map((r) => {
              const c = missing ? null : convertLine(r, to, fx);
              return (
                <div key={r.id} className="flex items-center justify-between gap-3 px-3 py-1.5" data-testid={`ws-convert-row-${r.id}`}>
                  <span className="truncate text-slate-300">{r.product_name}</span>
                  <span className="font-mono whitespace-nowrap tabular-nums">
                    <span className="text-slate-400">{fmtMoney(r.unit_price, r.currency || "TRY")}</span>
                    <ArrowRight className="inline w-3 h-3 mx-1.5 text-slate-600" />
                    <span className="text-blue-300 font-semibold">{c ? fmtMoney(c.unit_price, to) : "—"}</span>
                  </span>
                </div>
              );
            })}
          </div>
          {missing && <div className="text-rose-400" data-testid="ws-convert-missing">Kur bilgisi alınamadı — dönüşüm yapılamaz.</div>}
          <div className="text-slate-500">Onaylarsanız birim fiyat, iskonto tutarı ve uygulama fiyatları bu kurla çevrilir. Kayıt "Değişiklikleri Kaydet" ile yapılır.</div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="ws-convert-cancel" className="rounded-sm border-slate-700">Vazgeç</Button>
          <Button onClick={() => onConfirm(rows.map((r) => r.id), to)} disabled={missing} data-testid="ws-convert-confirm"
            className="rounded-sm bg-blue-600 hover:bg-blue-500">{rows.length > 1 ? `${rows.length} satırı çevir` : "Çevir"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
